import {getInitialRequestState, RequestState} from "../models/common/RequestState";



export type BasicDetailReducerState<T> = {
    [ key: number ]: {
        entry: T
        request: RequestState
    }
}

export interface BasicListReducerStateType< T >  {
    totalEntries: number
    entries: {
        current: T,
        request: RequestState
    }
}

export interface TotalsListReducerStateType< T, X >  {
    totals: X
    totalEntries: number
    entries: {
        current: T,
        request: RequestState
    }
}

export interface BasicReducerState<listType, detailedEntryType> extends BasicListReducerStateType<listType> {

    detailedEntries: BasicDetailReducerState<detailedEntryType>,
    changingRequest: RequestState

}

export function initialReducerState() {
    return {
        totalEntries: 0,
        entries: {
            current: null,
            request: getInitialRequestState()
        },
        detailedEntries: {},
        changingRequest: getInitialRequestState()
    };
}